var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('button',{on:{"click":function($event){return _vm.$adal.login()}}},[_vm._v("sign in")]),_c('button',{on:{"click":function($event){return _vm.$adal.logout()}}},[_vm._v("sign out")])])}
var staticRenderFns = []

export { render, staticRenderFns }